module.exports = __webpack_public_path__ + "img/test01-2.6c4bacbf.jpg";